<template>
    <el-dialog width="620px" title="产品编辑" :before-close="handleClickCancel" class="ordinary_dialog" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="ordinaryEditVisible" append-to-body>
        <div class="ordinary_edit_wrap" v-loading="loading">
            <el-form size="small" ref="productForm" label-position="top" :model="productForm"  :rules="productFormRules">
                <el-form-item :label="goodsType == 'stock' ? '产品别名' : '产品名称'" prop="goods_name">
                    <div style="margin-left: 62px;margin-top: -33px" class="label_position" v-if="goodsType == 'stock'"><span>（销售人员下订单时展示设置的产品别名）</span></div>
                    <el-input v-model="productForm.goods_name"  placeholder="请输入名称"></el-input>
                </el-form-item>

                <el-form-item label="产品图片" prop="image">
                    <div class="image_outer_wrap">
                        <ul  class="upload_image_list">
                            <li v-for="(item,index) in productForm.image"
                                :key="index"
                                class="upload_image_item">
                                <i @click="productForm.image.splice(index,1)" class="el-icon-error"></i>
                                <el-image
                                        :preview-src-list="productForm.image.map(img=>img)"
                                        :src="item"
                                        fit="cover">
                                </el-image>

                            </li>
                            <li class="image_upload_wrap">
                                <input accept=".png, .jpg, .jpeg"
                                       class="upload_input"
                                       multiple
                                       type="file"
                                       @change="handleClickUploadImg($event,productForm.image)">
                                <i class="el-icon-plus"></i>
                            </li>
                        </ul>
                        <p class="image_hint">从本地上传图片，支持多张上传、多种图片格式。</p>
                    </div>
                </el-form-item>

                <el-form-item label="计量单位" prop="unit">
                    <el-input v-model="productForm.unit"  placeholder="请输入计量单位" maxlength="10" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="是否需要出入库" prop="can_in_out_stock" v-if="goodsType != 'stock'">
                    <template v-slot:label>
                        <div class="flex_wrap">
                            <span>是否需要入库</span>
                            <div class="label_position ml_16"><el-switch  v-model="productForm.can_in_out_stock" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="productForm.can_in_out_stock == 1 ?'是' : '否'">是</span></div>
                        </div>
                    </template>
                </el-form-item>

                <el-form-item label="产品描述" prop="description">
                    <el-input v-model="productForm.description" type="textarea"  placeholder="请输入产品描述" ></el-input>
                </el-form-item>

                <el-form-item label="成本价" prop="cost_price">
                    <template v-slot:label>
                        <div class="flex_wrap">
                            <span>成本价</span>
                            <div class="label_position"><span>（用于计算订单中的产品利润）</span></div>
                        </div>
                    </template>
                    <el-input v-model="productForm.cost_price" @blur="handleBlurPrice('cost_price')"   placeholder="请输入" ></el-input>
                </el-form-item>

                <el-form-item label="是否可销售" prop="is_sale">
                    <template v-slot:label>
                        <div class="flex_wrap">
                            <span>是否可销售</span>
                            <div class="label_position ml_16"><el-switch  v-model="productForm.is_sale" :active-value="1" :inactive-value="0"  active-color="#2990FF"></el-switch><span class="ml_8" v-text="productForm.is_sale == 1 ?'是' : '否'"></span></div>
                        </div>
                    </template>
                    <p class="hint">开关关闭，在下订单时该产品不允许销售</p>
                </el-form-item>

                <el-form-item label="销售指导价" prop="sale_price" v-if="productForm.is_sale">
                    <el-input v-model="productForm.sale_price" @blur="handleBlurPrice('sale_price')" placeholder="请输入" ></el-input>
                </el-form-item>

                <el-form-item label="是否可租借" prop="is_lease">
                    <template v-slot:label>
                        <div class="flex_wrap">
                            <span>是否可租借</span>
                            <div class="label_position ml_16"><el-switch  v-model="productForm.is_lease" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="productForm.is_lease == 1 ?'是' : '否'"></span></div>
                        </div>
                    </template>
                    <p class="hint">开关关闭，在下订单时该产品不允许租借</p>
                </el-form-item>

                <el-form-item label="租借指导价" prop="lease_price" v-if="productForm.is_lease">
                    <el-input v-model="productForm.lease_price" @blur="handleBlurPrice('lease_price')"    placeholder="请输入" ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { GoodsStockProductDetail , GoodsCustomProductDetail,GoodsStockProductEdit, GoodsCustomProductEdit} from '@/api'
import {uploadImg} from '@/utils/uploadOss'
export default {
    name: 'ordinary_edit', //库存产品  自定义产品
    props: {
        ordinaryEditVisible: {
            type: Boolean,
            default: false,
        },
        goodsId: {
            type: Number,
            default: 0,
        },
        goodsType: {
            type: String,
            default: '',
        },
        goodsInfo: {
            type: Object,
            default: ()=>{},
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            productForm:{
                goods_name: "",
                image: [],
                unit: "",
                description: "",
                cost_price: "",
                is_sale: 1,
                is_lease: 1,
                sale_price: "",
                lease_price: "",
                can_in_out_stock: 1,
            },
            productFormRules:{
                goods_name:[{ required: true, message: '请填写名称', trigger: 'blue'}],
            },

        }
    },
    created() {
        if(this.goodsId){
            this.getGoodsDetail()
        }
        if(this.goodsInfo){
            this.productForm = JSON.parse(JSON.stringify(this.goodsInfo))

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        getGoodsDetail(){
            let postData = {
                goods_id : this.goodsId
            }
            this.loading = true
            if(this.goodsType == 'stock'){
                GoodsStockProductDetail(postData).then(res => {
                    if (res.code === 200) {
                        let { goods_name, image, unit, description, cost_price, is_sale, is_lease, sale_price, lease_price, can_in_out_stock} = res.data
                        this.productForm = {
                            goods_name,
                            image:image ? image : [],
                            unit,
                            description,
                            cost_price,
                            is_sale,
                            is_lease,
                            sale_price,
                            lease_price,
                            can_in_out_stock
                        }
                    }
                    this.loading = false
                })
            }else if(this.goodsType == 'custom'){
                GoodsCustomProductDetail(postData).then(res => {
                    if (res.code === 200) {
                        let { goods_name, image, unit, description, cost_price, is_sale, is_lease, sale_price, lease_price, can_in_out_stock,product_name,sku_id,sku_key} = res.data
                        this.productForm = {
                            goods_name,
                            product_name,
                            sku_id,
                            sku_key,
                            image:image ?  image  : [],
                            unit,
                            description,
                            cost_price,
                            is_sale,
                            is_lease,
                            sale_price,
                            lease_price,
                            can_in_out_stock
                        }
                    }
                    this.loading = false
                })
            }
        },

        handleBlurPrice(field){
            let price = this.productForm[field].replace(',', '')
            price = this.productForm[field].replace(/[^\d.]/g, '')
            if(price < 0){
                this.productForm[field] = 0
            }
            price = Number(price).toFixed(2)
            this.productForm[field] =  Number(price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        },
        handleClickConfirm(){
            this.$refs.productForm.validate(valid => {
                if (valid) {
                    if(this.goodsId){
                        if(this.goodsType == 'stock'){
                            let postData = {
                                goods_id : this.goodsId,
                                goods_name:this.productForm.goods_name,
                                image:this.productForm.image,
                                unit:this.productForm.unit,
                                description:this.productForm.description,
                                cost_price:this.productForm.cost_price ? this.productForm.cost_price.replace(/,+/g, '') : 0,
                                is_sale:this.productForm.is_sale,
                                is_lease:this.productForm.is_lease,
                                sale_price:this.productForm.sale_price ? this.productForm.sale_price.replace(/,+/g, '') : 0,
                                lease_price:this.productForm.lease_price ? this.productForm.lease_price.replace(/,+/g, '') : 0,
                                is_online:this.productForm.is_sale == 0 && this.productForm.is_lease == 0 ? 0 : 1
                            }
                            this.BtnDisabled = true
                            GoodsStockProductEdit(postData).then(res => {
                                if (res.code === 200) {
                                    this.$message({
                                        message: '编辑成功',
                                        type: 'success',
                                        duration: 1000,
                                        onClose: () => {
                                            this.BtnDisabled = false
                                            this.$emit('success')
                                            this.handleClickCancel()
                                        }
                                    })
                                }else{
                                    this.BtnDisabled = false
                                }

                            })

                        }else if(this.goodsType == 'custom'){
                            let postData = {
                                goods_id : this.goodsId,
                                goods_name:this.productForm.goods_name,
                                image:this.productForm.image,
                                unit:this.productForm.unit,
                                description:this.productForm.description,
                                cost_price:this.productForm.cost_price ? this.productForm.cost_price.replace(/,+/g, '') : 0,
                                is_sale:this.productForm.is_sale,
                                is_lease:this.productForm.is_lease,
                                sale_price:this.productForm.sale_price ? this.productForm.sale_price.replace(/,+/g, '') : 0,
                                lease_price:this.productForm.lease_price ? this.productForm.lease_price.replace(/,+/g, '') : 0,
                                product_name:this.productForm.product_name,
                                sku_id:this.productForm.sku_id,
                                sku_key:this.productForm.sku_key,
                                can_in_out_stock:this.productForm.can_in_out_stock,
                                is_online:this.productForm.is_sale == 0 && this.productForm.is_lease == 0 ? 0 : 1
                            }
                            this.BtnDisabled = true
                            GoodsCustomProductEdit(postData).then(res => {
                                if (res.code === 200) {
                                    this.$message({
                                        message: '编辑成功',
                                        type: 'success',
                                        duration: 1000,
                                        onClose: () => {
                                            this.BtnDisabled = false
                                            this.$emit('success')
                                            this.handleClickCancel()
                                        }
                                    })
                                }else{
                                    this.BtnDisabled = false
                                }
                            })
                        }
                    }else{
                        this.$emit('success',this.productForm)
                        this.handleClickCancel()
                    }
                }
            })
        },


        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:ordinaryEditVisible', false)
        },

        // 上传产品图片
        handleClickUploadImg(e,field) {
            const files = Array.from(e.target.files)
            if (field.length === 5) return this.$message.error('最多只能上传5张图片')
            if(files.length + field.length > 5) return this.$message.error('最多只能上传5张图片')
            files.forEach(file => {
                if(file.type != 'image/png' && file.type != 'image/jpeg'){
                    this.$message.error(`${file.name}文件格式不正确`)
                    return false
                }
                uploadImg(file, 2).then(res => {
                    if (res.file_path) {
                        field.push(res.file_path)
                        e.target.value = ''
                    }
                }).catch(error => {
                    e.target.value = ''
                })

            })
        },

    },

}
</script>
<style lang="scss" scoped>
@import "@/styles/product_shelves.scss";
</style>
